<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getReportMTBFs"
				 @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
						<app-input-datepicker-range  id="fieldset-filter-period-date" label-cols-sm="4" label-cols-lg="3" label="Period Date " size="sm" :modelFrom.sync="filter.filterPeriodDateFrom" :modelTo.sync="filter.filterPeriodDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="filterMachineCodes" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Machine Code " id="filter-" size="sm" :model.sync="filter.filterMachineCode" @input="getFilterMachineCodes" @focus="getFilterMachineCodes" />
					</b-col>
					<b-col cols="12" lg="6">
						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getReportMTBFs"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
						   rounded
						   opacity="0.6"
						   spinner-small
						   spinner-variant="primary"
						   class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Report M T B F</span>
				</b-col>
				<b-col>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download All To Excel</b-button>
					
					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table :stacked="isStacked" id="table-list-reportmtbf" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="light" :bordered="true" :no-local-sorting="true" :items="reportMtbfs" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="reportMtbfs.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
				<b-th stacked-heading="Date" class="table-filter">
					<!-- <b-form-input id="input-start-production-table" @input="getReportMTBFsWithoutLoading" v-model="filter.startProduction" size="sm"></b-form-input> -->
					<app-input-datepicker-range @change="getReportMTBFsWithoutLoading" id="fieldset-filter-period-date" label-cols-sm="4" label-cols-lg="3" label="Period Date " size="sm" :modelFrom.sync="filter.filterPeriodDateFrom" :modelTo.sync="filter.filterPeriodDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
				</b-th>
				<b-th stacked-heading="Mesin" class="table-filter">
					<!-- <b-form-input id="input-code-table" @input="getReportMTBFsWithoutLoading" v-model="filter.code" size="sm"></b-form-input> -->
					<app-input-combobox-autocomplete @change="getReportMTBFsWithoutLoading" :options="filterMachineCodes" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Machine Code " id="filter-" size="sm" :model.sync="filter.filterMachineCode" @input="getFilterMachineCodes" @focus="getFilterMachineCodes" />
				</b-th>
				<b-th stacked-heading="Total Waktu Mesin Beroperasi (Menit)" class="table-filter">
					<!-- <b-form-input id="input-total-waktu-mesin-beroperasi-table" @input="getReportMTBFsWithoutLoading" v-model="filter.totalWaktuMesinBeroperasi" size="sm"></b-form-input> -->
				</b-th>
				<b-th stacked-heading="Total Frekuensi Trouble Mesin" class="table-filter">
					<!-- <b-form-input id="input-total-frekuensi-trouble-mesin-table" @input="getReportMTBFsWithoutLoading" v-model="filter.totalFrekuensiTroubleMesin" size="sm"></b-form-input> -->
				</b-th>
				<b-th stacked-heading="MTTR" class="table-filter">
					<!-- <b-form-input id="input-mttr-table" @input="getReportMTBFsWithoutLoading" v-model="filter.mttr" size="sm"></b-form-input> -->
				</b-th>
				<b-th stacked-heading="MTBF" class="table-filter">
					<!-- <b-form-input id="input-mtbf-table" @input="getReportMTBFsWithoutLoading" v-model="filter.mtbf" size="sm"></b-form-input> -->
				</b-th>
				<b-th stacked-heading="Total Mesin Trouble" class="table-filter">
					<!-- <b-form-input id="input-total-waktu-mesin-trouble-table" @input="getReportMTBFsWithoutLoading" v-model="filter.totalWaktuMesinTrouble" size="sm"></b-form-input> -->
				</b-th>
				<b-th stacked-heading="Availability" class="table-filter">
					<!-- <b-form-input id="input-availability-table" @input="getReportMTBFsWithoutLoading" v-model="filter.availability" size="sm"></b-form-input> -->
				</b-th>

					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
					</template>

					<template v-slot:head(frontAction)>
						<div class="d-flex justify-content-center ml-2">
							<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right">
								<b-icon-funnel />
							</b-button>
						</div>
					</template>
					
					<template v-slot:cell(startProduction)="row">
						{{ row.item.startProduction | moment("DD-MMM-YYYY") }}
					</template>

					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
						<app-input-textbox id="fieldset-total-waktu-mesin-beroperasi" label-cols-lg="12"  label="Total Waktu Mesin Beroperasi (Menit)" label-for="input-total-waktu-mesin-beroperasi" size="sm" :model.sync="row.item.totalWaktuMesinBeroperasi"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-total-frekuensi-trouble-mesin" label-cols-lg="12"  label="Total Frekuensi Trouble Mesin" label-for="input-total-frekuensi-trouble-mesin" size="sm" :model.sync="row.item.totalFrekuensiTroubleMesin"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-mttr" label-cols-lg="12"  label="MTTR" label-for="input-mttr" size="sm" :model.sync="row.item.mttr"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-mtbf" label-cols-lg="12"  label="MTBF" label-for="input-mtbf" size="sm" :model.sync="row.item.mtbf"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-total-waktu-mesin-trouble" label-cols-lg="12"  label="Total Mesin Trouble" label-for="input-total-waktu-mesin-trouble" size="sm" :model.sync="row.item.totalWaktuMesinTrouble"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-availability" label-cols-lg="12"  label="Availability" label-for="input-availability" size="sm" :model.sync="row.item.availability"   :isEditable="false" :isUpdatable="true" />

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="d-flex justify-content-center">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
											  v-model="currentPage"
											  :total-rows="(reportMtbfsPaging != null ? reportMtbfsPaging.dataCount : 0)"
											  :per-page="(reportMtbfsPaging != null ? reportMtbfsPaging.pageSize : 0)"
											  aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
		<PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
		<RouterView />
	</div>
</template><style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    

    ::v-deep #table-list-reportmtbf.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

    ::v-deep #table-list-reportmtbf.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }
</style>
<script>
import ReportMTBF from '@/models/ReportMTBF/ReportMTBF';
import ReportMTBFList from '@/models/ReportMTBF/ReportMTBFList';
import ReportMTBFFilter from '@/filters/ReportMTBF/ReportMTBFFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextbox from '@/components/AppInputTextbox';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
export default {
	components : {
		ReportMTBF, 
		ReportMTBFList, 
		ReportMTBFFilter, 
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppInputTextbox,
		PopupDownload,
		PopupPDF,
		PopupDataEditNotification,
	},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"no" : {"class" : "th-number d-stack-none"}},
				{"frontAction" : {"class" : "th-number d-stack-none"}},
				{"startProduction": {}, "class" : "th-start-production first-child", "label" : "Date", key: 'startProduction', }, 
				{"code": {}, "class" : "th-code", "label" : "Mesin", key: 'code', }, 
				{"totalWaktuMesinBeroperasi": {}, "class" : "th-total-waktu-mesin-beroperasi last-child", "label" : "Total Waktu Mesin Beroperasi (Menit)", key: 'totalWaktuMesinBeroperasi', }, 
				{"totalWaktuTroubleMesin": {}, "class" : "th-total-waktu-trouble-mesin last-child", "label" : "Total Waktu Trouble Mesin", key: 'totalWaktuTroubleMesin', }, 
				{"totalFrekuensiTroubleMesin": {}, "class" : "th-total-frekuensi-trouble-mesin d-stack-none", "label" : "Total Frekuensi Trouble Mesin", key: 'totalFrekuensiTroubleMesin', }, 
				{"mttr": {}, "class" : "th-mttr d-stack-none", "label" : "MTTR", key: 'mttr', }, 
				{"mtbf": {}, "class" : "th-mtbf d-stack-none", "label" : "MTBF", key: 'mtbf', }, 
				{"totalWaktuMesinTrouble": {}, "class" : "th-total-waktu-mesin-trouble d-stack-none", "label" : "Total Mesin Trouble", key: 'totalWaktuMesinTrouble', }, 
				{"availability": {}, "class" : "th-availability d-stack-none", "label" : "Availability", key: 'availability', }, 

			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			reportMtbfs: [],
			reportMtbfsPaging: {},
			filterMachineCodes : [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
		}
	},	methods : {
		getReportMTBFs : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			ReportMTBF.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.reportMtbfs = result.data
					this.reportMtbfsPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getReportMTBFsWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			ReportMTBF.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.reportMtbfs = result.data
					this.reportMtbfsPaging = result
				}
			})
			.catch(error => {});
		},
		getFilterMachineCodes : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportMTBF.getListCustomUrl(this,'getlistfiltermachinecode' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterMachineCodes = result.data
				}
			})
			.catch(error => {});
		},

		resetFilter() {
			this.filter = new ReportMTBFFilter();
			this.getReportMTBFs();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getReportMTBFs();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				ReportMTBF.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			ReportMTBF.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			console.log('this.filter', this.filter);
			ReportMTBF.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				console.log('result ', result);
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},

		deleteData(id) {
			ReportMTBF.deleteData(this, id).then(result => {
				if (result)
				{
					this.getReportMTBFs();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				ReportMTBF.deleteMultipleData(this).then(result => {
					this.getReportMTBFs();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tableReportMTBFParent = document.getElementById('table-list-reportmtbf').parentNode;
			tableReportMTBFParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableReportMTBFParent.scrollWidth - tableReportMTBFParent.offsetWidth) == Math.ceil(tableReportMTBFParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableReportMTBFParent = document.getElementById('table-list-reportmtbf').parentNode;
			tableReportMTBFParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableReportMTBFParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new ReportMTBFFilter();
		this.getFilterMachineCodes()
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Report M T B F"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getReportMTBFs();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getReportMTBFs();
			}
		},
		sortDesc: {
			handler: function() {
				this.getReportMTBFs();
			}
		},
		currentPage: {
			handler: function() {
				this.getReportMTBFs();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getReportMTBFs();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				ReportMTBF.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "reportmtbfindex") {
					this.getReportMTBFsWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "report_m_t_b_f").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
